// @flow
import React, {PureComponent} from 'react';
import { getDateFromString, formatFullDate } from 'utils/dateUtils';
import MatchResult from 'components/fragments/MatchResult';
export type StateProps = {
  datas: Object
};

type Props = StateProps;

class TeamMenuLastResult extends PureComponent<Props> {
  _lastresults = () => {
    const { dernieres_rencontres } = this.props.datas;
    let competition = false;
    return dernieres_rencontres.map((card, index) => {
      let newcompetition = false;
      if (card.competition !== competition) {
        competition = card.competition;
        newcompetition = true;
      }
      return (
        <div key={index}>
          {newcompetition && index > 0 && <hr style={{marginTop: 0, marginBottom: '10px'}} />}
          <MatchResult
            url={card.link}
            adversaire={card.adversaire}
            reception={card.reception}
            score_france={card.france_score}
            score_adversaire={card.adversaire_score}
            logo_france={card.embleme_france}
            logo_adversaire={card.embleme_adversaire}
            date_rencontre={formatFullDate(getDateFromString(card.date_rencontre))}
            journee={card.journee}
            competition={newcompetition === true ? {name: card.competition} : {}}
          />
        </div>
      );
    });
  }

  render() {
    return (<div className="col col-md-12 col-lg-5 mb-2 mb-lg-0">
      <div className="box box--white card card--result ">
        <div className="card__body">
          <h3 className="mb-2">Derniers résultats</h3>
          {this._lastresults()}
        </div>
        <div className="card__footer">
          <a href={this.props.datas.link_results} className="link-chevron link-chevron--block" data-label="">
            <span>{"Voir tous les résultats de l’équipe"}</span>
            <i className="icon icon-chevron-right"></i>
          </a>
        </div>
      </div>
    </div>);
  }
};

export default TeamMenuLastResult;
